var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.0004 8.93107C31.238 8.21654 32.7628 8.21654 34.0004 8.93107L50.9787 18.7335C52.2163 19.4481 52.9787 20.7686 52.9787 22.1976V41.8026C52.9787 43.2317 52.2163 44.5522 50.9787 45.2667L34.0004 55.0692C32.7627 55.7837 31.238 55.7837 30.0004 55.0692L13.022 45.2667C11.7844 44.5522 11.022 43.2316 11.022 41.8026V22.1976C11.022 20.7686 11.7844 19.4481 13.022 18.7335L30.0004 8.93107Z","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
